<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Identificação do usuário"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input
                        :value="form.usuario.nome"
                        disabled
                        label="Nome"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.dataNascimento"
                        disabled
                        label="Data de nascimento"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.cpf"
                        disabled
                        label="CPF"
                    />
                </rkm-col>

                <rkm-col cols="2">
                    <rkm-form-input
                        :value="form.usuario.cns"
                        disabled
                        label="CNS"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Origem"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-select
                                :options="form.origem.unidades"
                                :validations="validations.unidade"
                                @change="handleUnidadeChange"
                                label="Unidade"
                                show-default-option
                                text-field="nomeFantasia"
                                v-model="model.origem.unidadeId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-select
                                :options="form.origem.infraestruturas"
                                :validations="validations.infraestrutura"
                                @change="handleInfraestruturaChange"
                                label="Local de atendimento"
                                show-default-option
                                text-field="nome"
                                v-model="model.origem.infraestruturaId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-select
                                :options="form.origem.ocupacoes"
                                :validations="validations.ocupacao"
                                @change="handleOcupacaoChange"
                                label="CBO"
                                show-default-option
                                text-field="descricao"
                                v-model="model.origem.ocupacaoId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-select
                                :options="form.origem.especialidades"
                                :validations="validations.especialidade"
                                @change="handleEspecialidadeChange"
                                label="Especialidade"
                                show-default-option
                                text-field="nome"
                                v-model="model.origem.especialidadeId"
                                value-field="id"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-col>

                <rkm-col
                    class="mt-1"
                    cols="6"
                >
                    <rkm-calendar
                        :items="feriados.concat(datas)"
                        @click="handleCalendarioClick"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <ModalAcao
            @cancel="$refs.ModalCancelamento.open($event)"
            @destiny="$refs.ModalDestino.open($event)"
            @reschedule="$refs.ModalReagendamento.open($event)"
            ref="ModalAcao"
        />

        <ModalCancelamento
            :data="{form, model}"
            :usuario-id="id"
            @saved="getDatas(model.origem.infraestruturaId, model.origem.especialidadeId)"
            ref="ModalCancelamento"
        />

        <ModalDestino
            :data="{form, model}"
            @reschedule="$refs.ModalReagendamento.open($event)"
            ref="ModalDestino"
        />

        <ModalReagendamento
            :data="{form, model}"
            :usuario-id="id"
            @closed="getDatas(model.origem.infraestruturaId, model.origem.especialidadeId)"
            ref="ModalReagendamento"
        />
    </div>
</template>

<script>
// Components.
import ModalAcao from './components/tipo-acao/Modal'
import ModalCancelamento from './components/cancelamento/Modal'
import ModalDestino from './components/destino/Modal'
import ModalReagendamento from './components/reagendamento/Modal'

// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    components: {
        ModalAcao,
        ModalCancelamento,
        ModalDestino,
        ModalReagendamento,
    },
    computed: {
        feriados() {
            return this.form.origem.feriados.map(feriado => {
                return {
                    dates: this.others.moment(feriado.data, 'DD/MM/YYYY'),
                    highlight: 'yellow',
                    popover: feriado.observacao,
                    title: feriado.tipoDescricao,
                }
            })
        },
        datas() {
            return this.form.origem.datas.map(data => {
                return {
                    dates: this.others.moment(data.data, 'DD/MM/YYYY'),
                    highlight: data.quantidadeAgendada >= data.quantidadeTotal ? 'red' : 'green',
                    title: `${data.quantidadeAgendada} / ${data.quantidadeTotal}`,
                }
            })
        },
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required: true},
                ocupacao: {required: true},
                especialidade: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            gerenciamentoMedico: this.getConectaSusRepository('ambulatorio.gerenciamentoMedico'),
        }
    },
    data: () => ({
        form: null,
        model: null,
        others: {moment},
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.gerenciamentoMedico.edit(this.id)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                    this.$emit('loaded', {form: this.form, model: this.model})
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.origem.infraestruturas = []
            this.form.origem.ocupacoes = []
            this.form.origem.especialidades = []
            this.form.origem.datas = []
            this.model.origem.infraestruturaId = null
            this.model.origem.ocupacaoId = null
            this.model.origem.especialidadeId = null

            if (value === null) return

            this.getInfraestruturas(value)
        },
        handleInfraestruturaChange(value) {
            this.form.origem.ocupacoes = []
            this.form.origem.especialidades = []
            this.form.origem.datas = []
            this.model.origem.ocupacaoId = null
            this.model.origem.especialidadeId = null

            if (value === null) return

            this.getOcupacoes(value)
        },
        handleOcupacaoChange(value) {
            this.form.origem.especialidades = []
            this.form.origem.datas = []
            this.model.origem.especialidadeId = null

            if (value === null) return

            this.getEspecialidades(this.model.origem.infraestruturaId, value)
        },
        handleEspecialidadeChange(value) {
            if (value === null) return

            this.getDatas(this.model.origem.infraestruturaId, value)
        },
        handleCalendarioClick(value) {
            const data = this.form.origem.datas
                .filter(data => !this.form.origem.feriados.find(feriado => feriado.data === data.data))
                .find(data => this.others.moment(data.data, 'DD/MM/YYYY').isSame(value.date))

            if (data) {
                this.$refs.ModalAcao.open(value.date)
            }
        },
        async getInfraestruturas(unidadeId) {
            const request = {
                origem: 'origem',
                listar: 'infraestruturas',
                usuarioId: this.id,
                unidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.origem.infraestruturas = Object.assign(response.data.infraestruturas)

                if (this.form.origem.infraestruturas.length === 1) {
                    const selected = this.form.origem.infraestruturas[0]
                    this.model.origem.infraestruturaId = selected.id

                    this.getOcupacoes(this.model.origem.infraestruturaId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getOcupacoes(infraestruturaId) {
            const request = {
                origem: 'origem',
                listar: 'ocupacoes',
                usuarioId: this.id,
                infraestruturaId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.origem.ocupacoes = Object.assign(response.data.ocupacoes)

                if (this.form.origem.ocupacoes.length === 1) {
                    const selected = this.form.origem.ocupacoes[0]
                    this.model.origem.ocupacaoId = selected.id

                    this.getEspecialidades(infraestruturaId, this.model.origem.ocupacaoId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getEspecialidades(infraestruturaId, ocupacaoId) {
            const request = {
                origem: 'origem',
                listar: 'especialidades',
                usuarioId: this.id,
                infraestruturaId,
                ocupacaoId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.origem.especialidades = Object.assign(response.data.especialidades)

                if (this.form.origem.especialidades.length === 1) {
                    const selected = this.form.origem.especialidades[0]
                    this.model.origem.especialidadeId = selected.id

                    this.getDatas(infraestruturaId, this.model.origem.especialidadeId)
                }
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        async getDatas(infraestruturaId, especialidadeId) {
            const request = {
                origem: 'origem',
                listar: 'datas',
                usuarioId: this.id,
                infraestruturaId,
                especialidadeId,
            }

            this.setLoading()

            try {
                const response = await this.repositories.gerenciamentoMedico.list(this.camelObjectKeysToSnakeRecursive(request))

                this.form.origem.datas = Object.assign(response.data.datas)
            }
            catch (error) {
                this.handleError(error)
            }
            finally {
                this.unsetLoading()
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = {
                        nome: this.model.nome,
                    }

                    if (this.id) {
                        this.repositories.gerenciamentoMedico.update(this.id, this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    } else {
                        this.repositories.gerenciamentoMedico.store(this.camelObjectKeysToSnakeRecursive(request))
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('saved', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
    },
    mixins: [error, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number, required: true},
    },
}
</script>